// src/pages/PerformanceAssessments/index.js
import React, { useMemo, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CFormSelect, CRow } from '@coreui/react';
import { jwtDecode } from 'jwt-decode';

import PendingPerformanceAssessments from './pendingPerformanceAssessments';
import MyPerformanceResults from './myPerformanceResults';
import ManagerPerformanceOverview from './managerPerformanceOverview';
import { AVAILABLE_YEARS } from './questions';

const PerformanceAssessmentsPage = () => {
    const token = localStorage.getItem('access_token');
    const decodedToken = token ? jwtDecode(token) : {};
    const is_manager = !!decodedToken.is_manager;

    const availableYears = useMemo(() => AVAILABLE_YEARS, []);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    return (
        <>
            <CCard className="mb-4">
                <CCardHeader>
                    <CRow className="align-items-center">
                        <CCol>
                            <strong>Avaliação de desempenho</strong>
                        </CCol>

                        <CCol xs="auto">
                            <CRow className="g-2 align-items-center">
                                <CCol xs="auto">
                                    <strong>Ano:&nbsp;</strong>
                                </CCol>
                                <CCol xs="auto">
                                    <CFormSelect
                                        size="sm"
                                        value={selectedYear}
                                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                                    >
                                        {availableYears.map((y) => (
                                            <option key={y} value={y}>
                                                {y}
                                            </option>
                                        ))}
                                    </CFormSelect>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody className="text-muted small">
                    Seleccione o ano para filtrar todas as secções desta página.
                </CCardBody>
            </CCard>

            {/* Avaliações pendentes onde o utilizador é avaliador */}
            <PendingPerformanceAssessments selectedYear={selectedYear} />

            {/* Avaliações concluídas onde o utilizador é avaliado (C1–C4) */}
            <MyPerformanceResults selectedYear={selectedYear} />

            {/* Visão global – apenas managers */}
            {is_manager && (
                <ManagerPerformanceOverview selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            )}
        </>
    );
};

export default PerformanceAssessmentsPage;
